<div mat-dialog-content>
  <p class="message">{{ data.message }}</p>
</div>
<div mat-dialog-actions class="action-div">
  <button mat-flat-button  color="warn"  (click)="onDismissClick()">{{data.noLabel}}</button>
  <button mat-flat-button color="primary" (click)="onConfirmClick()">{{data.yesLabel}}</button>
</div>
 